<template>
  <div class="knowledge-list">

      <div class="search">
          <van-search v-model="value" @click="goSearch()" @search="onSearch" @clear="onCancel" placeholder="搜一搜"></van-search>
      </div>

      <div class="tags">
          <van-tabs :swipeable="true" v-model="category_index" @click="changeCategory">
              <van-tab :title-class="'course-list-category-title'" v-for="(item,index) in categories" :key="index" :title="item.name" ></van-tab>
          </van-tabs>
          <div class="clear"></div>
      </div>

      <van-row>
          <van-col span="7">
              <div class="knowledge-list-sidebar-box">
                  <van-sidebar class="knowledge-list-sidebar" v-model="activeKey" @change="changeSidebar">
                      <van-sidebar-item v-for="item in treeData" :key="item.id" :title="item.name" />
                  </van-sidebar>
              </div>
          </van-col>
          <van-col span="17">
              <div class="knowledge-list-sidebar-section" v-if="list.length > 0" style="margin-top: 8px">
                  <van-list class="knowledge-list-sidebar-section-box">
                      <van-cell is-link class="knowledge-list-sidebar-section-title" @click="goList(item)" v-for="item in list" :key="item.id" :title="item.title" />
                  </van-list>
              </div>
          </van-col>
      </van-row>
  </div>
</template>
<script>
    import Interface from "@/util/interface"
    import articleListSkeleton from "@/skeleton/articleListSkeleton"
    export default {
        name: 'article-list',
        components :{
            'article-list-skeleton' : articleListSkeleton
        },
        data() {
            return {
                value: "",
                active: "",
                category_id :0,
                category_child_id:0,
                category_index:0,
                banners: [],
                categories: [],
                categories_child:[],
                recommend:[],
                list:[],
                column:[],
                loading:true,
                page:1,
                pageSize:20,
                total_page:1,
                items: [{ text: '分组 1' }, { text: '分组 2' }],

                activeIndex:0,
                activeId:0,

                treeData:[],
                activeKey:0,
                record_id: 0
            }
        },
        methods: {
            onSearch(){
                this.fetch('list')
            },
            onCancel() {
                this.value = ""
                this.fetch("list")
            },
            fetch(scene) {
                if (scene === 'category') {
                    let params = {
                        page:1,
                        pageSize:999,
                        type:9,
                    }
                    Interface.getData('get', Interface.category,params).then((res) => {
                        this.categories = res.data.list
                        this.changeCategory()
                    })

                } else if (scene === 'list') {
                    this.page = 1
                    let params = {
                        page:this.page,
                        pageSize:this.pageSize,
                        category_id : this.category_id,
                    }
                    if(this.value != ""){
                        params.category_id = 0
                        params.title = this.value
                    }
                    Interface.getData('get', Interface.knowledge.list,params).then((res) => {
                        if(res.data.list != null){
                            this.list = res.data.list
                            this.total_page = res.data.total_page
                        }else{
                            this.list = [];
                            this.total_page = 1
                        }
                        setTimeout(()=>{this.loading = false;},500)
                    })
                }
            },
            fetch_more(){
                this.page += 1
                let params = {
                    page : this.page,
                    pageSize:10,
                    category_id : this.category_id,
                }
                Interface.getData('get', Interface.knowledge.list,params).then((res) => {
                    this.list.push(...res.data.list)
                    this.total_page = res.data.total_page
                })
            },
            changeCategory(){
                this.activeKey = 0
                this.treeData = this.categories[this.category_index].children
                this.category_id = this.treeData[this.activeKey].id
                this.fetch('list')
            },
            changeSidebar(){
                this.category_id = this.treeData[this.activeKey].id
                this.fetch('list')
            },
            goList(item) {
              this.$router.push({name:'knowledge-list',params:{'id':item.id}})
              Interface.mFootPrint(item.id, 9,0, 3, 0, 0,0,item.title)
            },
            goSearch() {
                this.$router.push({name:'search', query: { pageType: 3 }})
                Interface.mFootPrint(0, 76,0, 3, 0, 0,0,'疾病库-搜索')
            }

        },
        created() {
            this.fetch('category')
            this.fetch('list')
            sessionStorage.removeItem("search_data")
            Interface.getShareInfo(this,"博医同行-学知识","","靠谱易懂的血液病及肿瘤科普百科", 98, '', Interface.host + '/#/knowledge-category?source_type=1')
            // Interface.footPrint(21,1,0,"浏览博医同行学知识")
            // Interface.mFootPrint(1, 9,0, 0, 0, 0,0,'疾病库列表页')
            // Interface.exposureFootPrint(JSON.stringify([{ origin_id: 0, type: 9, title: '疾病库列表页', page_type: 0}]))
            // Interface.mFootPrint(1, 98,0, 3, 0, 0,0,'疾病库列表页')
            Interface.getData('post',Interface.footprint, {
              id: 1,
              type: 98,
              content_type: 0,
              page_type: 3,
              source_type: 0,
              parent_id: 0,
              record_id: 0,
              title: '疾病库列表页'
            }).then( (res) => {
              if (res.code == 0) {
                this.record_id = res.data.record_id
              }
            })
        },
        beforeRouteLeave(to, from, next) {
          if (this.record_id) {
            Interface.mFootPrint(1, 98,0, 3, 0, 0,this.record_id,'疾病库列表页')
          }
          next()
        }
    }
</script>

<style lang="scss">
    @import "./index.scss";
</style>



// WEBPACK FOOTER //
// src/views/knowledge/category/index.vue